import styled from 'styled-components'
import { orange } from '@/theme/colors'
import { media } from '@/theme/tokens'
import { fontSizes, text } from '@/theme/typography'

export const BrandRoot = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 9px;

	img {
		width: 26px;
		height: 26px;
	}

	${media.phone} {
		gap: 7px;

		img {
			width: 22px;
			height: 22px;
		}
	}
`

export const BrandWordmark = styled.b`
	${text.heading}
	font-weight: 900;
	color: ${orange};

	${media.phone} {
		font-size: ${fontSizes.title};
	}
`
